import { render, staticRenderFns } from "./VSearchField.vue?vue&type=template&id=8b9eaaa2"
import script from "./VSearchField.vue?vue&type=script&lang=js"
export * from "./VSearchField.vue?vue&type=script&lang=js"
import style0 from "./VSearchField.vue?vue&type=style&index=0&id=8b9eaaa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports